<template>
  <app-status-chip :statuses="statuses" :value="value" />
</template>

<script>
export default {
  props: {
    value: {},
  },

  data: () => ({
    statuses: {
      foreseen: {
        text: "Previsão",
        color: "secondary",
      },
      scheduled: {
        text: "Agendado",
        color: "info",
      },
      renegotiated: {
        text: "Renegociado",
        color: "disabled",
      },
      to_pay: {
        text: "A Pagar",
        color: "primary",
      },
      paid: {
        text: "Pago",
        color: "success",
      },
      canceled: {
        text: "Cancelado",
        color: "error",
      },
    },
  }),
};
</script>

<style></style>
